export interface IScrollRef {
  howItWorkRef?: React.Ref<HTMLDivElement>;
}

export enum EScrollingBlocks {
  HowItWork = 'HowItWork',
}

export interface IScrollingBlock {
  id: EScrollingBlocks;
  ref: React.RefObject<HTMLElement | null>;
}

export type TScrollingBlocks = { [key in EScrollingBlocks]?: IScrollingBlock };

export type TActive = EScrollingBlocks | null;

export interface IScrollingContext {
  refBlocksState: TScrollingBlocks;
  setRefBlocksState: React.Dispatch<React.SetStateAction<TScrollingBlocks>>;
}
